// import { useState } from "react";
// import {
//   fetchOrganizerPavilions,
//   fetchPavilionById,
//   createPavilion,
//   updatePavilion,
//   deletePavilion as deletePavilionApi,
//   fetchPavilionsTree,
// } from "../../../api/pavilion.api";

// export const usePavilions = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [pavilions, setPavilions] = useState([]);

//   const loadPavilions = async (company_id) => {
//     setLoading(true);
//     const res = await fetchPavilionsTree({ company_id });
//     setData(res.data?.data || []);
//     setLoading(false);
//   };

//   const loadPavilionById = async (id) => {
//     try {
//       const res = await fetchOrganizerPavilions(id);
//       setPavilions(res.data?.data || []);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching pavilion by ID:", error);
//       setPavilions([]);
//     }
//   };

//   const addPavilion = (payload) => createPavilion(payload);
//   const editPavilion = (id, payload) => updatePavilion(id, payload);
//   const deletePavilion = async (id, payload) => {
//      const res = await deletePavilionApi(id, payload);
//         return res.data;
//       };

//   return {
//     data,
//     loading,
//     pavilions,
//     loadPavilions,
//     loadPavilionById,
//     addPavilion,
//     editPavilion,
//     deletePavilion,
//   };
// };

import { useState } from "react";
import {
  fetchOrganizerPavilions,
  createPavilion,
  updatePavilion,
  deletePavilion as deletePavilionApi,
  fetchPavilionsTree,
} from "../../../api/pavilion.api";

export const usePavilions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pavilions, setPavilions] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({
    totalPavilions: 0,
    totalPages: 1,
  });

  const loadPavilions = async (company_id, options = {}) => {
    if (!company_id) return;
    setLoading(true);
    try {
      const res = await fetchPavilionsTree({
        company_id,
        page: options.page || 1,
        limit: options.limit || 10,
        search: options.search || "",
      });

      const payload = res?.data || {};
      const list =
        payload.pavilions ||
        payload.data?.pavilions ||
        payload.data ||
        (Array.isArray(payload) ? payload : []);

      setData(list);

      setPaginationInfo({
        totalPavilions:
          payload.pagination?.totalPavilions || payload.total || list.length,
        totalPages: payload.pagination?.totalPages || payload.totalPages || 1,
      });
    } catch (error) {
      console.error("Error fetching pavilions tree:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadPavilionById = async (id) => {
    try {
      const res = await fetchOrganizerPavilions(id);
      setPavilions(res.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching pavilion by ID:", error);
      setPavilions([]);
    }
  };

  const addPavilion = (payload) => createPavilion(payload);
  const editPavilion = (id, payload) => updatePavilion(id, payload);
  const deletePavilion = async (id, payload) => {
    const res = await deletePavilionApi(id, payload);
    return res.data;
  };

  return {
    data,
    loading,
    pavilions,
    paginationInfo,
    loadPavilions,
    loadPavilionById,
    addPavilion,
    editPavilion,
    deletePavilion,
  };
};